export const trainingEvents = {
  openTrainingList: 'Open all training courses',
  openTrainingInsights: 'Open training insights',
  goToAllTrainings: 'Go to all training courses',
  goToInsights: 'Go to trainings insights',
  goToCategories: 'Go to categories',
  goToAssignedEmployees: 'Go to training assigned employees',
  session: {
    cancel: 'Add training session cancel',
    start: 'Add training session start',
    submit: 'Add training session submit',
    assignEmployeesCancel: 'Add employee to training cancel',
    assignEmployeesSubmit: 'Add employee to training submit',
    assignEmployeesStart: 'Add employee to training start',
    duplicate: 'Duplicate session',
  },
  trainingRequest: {
    rejectTrainingRequest: {
      cancel: 'Reject training request cancel',
      submit: 'Reject training request submit',
      start: 'Reject training request start',
    },
    approveTrainingRequest: {
      submit: 'Approve training request submit',
    },
    addTrainingRequest: {
      add: 'Add training request',
      fromCatalog: {
        submit: 'Add training request from catalog submit',
        cancel: 'Add training request from catalog cancel',
        back: 'Add training request from catalog back',
        next: 'Add training request from catalog next',
        start: 'Add training request from catalog start',
      },
      newProposal: {
        submit: 'Add training request new proposal submit',
        cancel: 'Add training request new proposal cancel',
        back: 'Add training request new proposal back',
        next: 'Add training request new proposal next',
        start: 'Add training request new proposal start',
      },
    },
    goToTrainingRequest: 'Go to training request',
    goToTrainingRequests: 'Go to training requests',
    gotToTrainingCatalog: 'Go to training catalog',

    goToMyTrainingRequestsEmptyState: 'View my training requests empty space',
    goToTrainingCatalogEmptyState: 'View employee training catalog empty space',
    filterMyRequests: 'Filter my requests',
    filterPublicTrainings: 'Filter public trainings',
    participantDetail: 'View participant detail',
    applicantDetail: 'View applicant detail',
    saveTrainingRequest: 'Save training request',
  },
  addTrainingSubmit: 'Add training submit',
  addTrainingCancel: 'Add training cancel',
  addTrainingStart: 'Add training start',
  trainingCreation: {
    submit: 'Add training course submit',
    cancel: 'Add training course cancel',
    back: 'Add training course back',
    next: 'Add training course next',
    start: 'Add training course start',
    files: {
      uploadFile: {
        start: 'Go to upload training file modal',
        submit: 'Upload file to training submit',
        cancel: 'Upload file to training cancel',
      },
      delete: 'Delete training file',
      visibility: 'Change training file visibility',
    },
  },
  upsell: {
    fundae: {
      image: {
        see: 'Seeing the pop up with images',
        close: 'Closing the pop up with images',
      },
      text: {
        see: 'Seeing the pop up with text',
        close: 'Closing the pop up with text',
      },
    },
  },
  //TODO: Clean this file
  duplicate: {
    goToDuplicateGroups: 'Click on duplicate group',
    saveDuplicateGroup: 'Save duplicate group',
    goToDuplicateCourse: 'Click on duplicate course',
    saveDuplicateCourse: 'Save duplicate course',
  },
  trainingCreationWizard: {
    goToNewCourseWizard: 'Click on new course start',
    goToBasicInfoNextStep: 'Click on continue basic info new course',
    saveNewCourseWizard: 'Click on save admin information new course',
  },
  trainingsFilters: {
    tagsFilter: 'Click on tags filter',
    competenciesFilter: 'Click on competencies filter',
    statusFilter: 'Click on status filter',
    participantFilter: 'Click on participant filter',
    retakeFilter: 'Click on retake filter',
    yearFilter: 'Click on year filter',
  },
  trainingGroupCreationWizard: {
    goToNewGroupWizard: 'Click on new group start',
    goToDetailsNextStep: 'Click on continue details new group',
    goToSessionsNextStep: 'Click on continue sessions new group',
    goToParticipantsNextStep: 'Click on continue participants new group',
    saveNewGroupWizard: 'Click on save materials new group',
  },
  trainingWorkflows: {
    linkWorkflowCreation: 'Click on link course with workflows course creation',
    linkWorkflowEdition: 'Click on link course with workflows course edition',
    goToCertificateDatatable: 'Click on certificate link in participant table',
    goToCertificateSidepanel: 'Click on view certificate from participant side panel',
  },
  trainingDetail: {
    fundae: {
      finishGroupsExport: {
        exportXml: 'Click on export xml',
        saveExportXml: 'Click on save export xml',
        matchData: 'Click on match data new',
        settingsProfessionalCategory: 'Click on settings fundae professional category',
        settingsEducationalLevel: 'Click on settings fundae educational level',
        missingDataFilter: 'Click on missing data filter new',
      },
    },
  },
  salaryCostCalculator: {
    apply: 'Click on salary cost calculate apply',
    calculate: 'Click on salary cost calculate start',
  },
  trainingClass: {
    editClass: 'Click on edit group',
    saveEditClass: 'Click on save edit group',
  },
  trainingSession: {
    viewSession: 'Click on view session',
    selectParticipant: 'Click select participant',
    selectAttendanceStatus: 'Click on attendance button',
    applyFilterAttendanceStatus: 'Click on filter attendance status apply',
    applyFilterModality: 'Click on filter modality apply',
    filterStartDate: 'Click on filter start date',
    applyFilterStartDate: 'Click on apply filter start date',
    startNewSession: 'Click on new session start',
    saveNewSession: 'Click on new session save',
    addReminderStart: 'Click on add reminder start',
    addReminderConfirm: 'Add reminder confirm',
    editSessionStart: 'Click on edit session start',
    editSessionSave: 'Click on edit session save',
    duplicateSession: 'click on duplicate session',
  },
  videoTracking: {
    progress: 'Training video progress',
  },
}
